import { merge } from 'lodash';

import { withContext } from '../../../../../utils/workflow/withContext';
import { incomeFormConfig } from '../../../../common/Steps/ApplicantIncome/Model';
import { applicantBaseModel } from '../../../../common/Steps/common/ApplicantBaseModel';
import { Signal } from '../../XState/Model';
import BaseModel from '../common/BaseModel';
import { getIncomesList } from './utils';

const model = (send: any, { context }: any) => {
  const options = getIncomesList(context.updatedUser.incomes);
  return merge(
    {},
    applicantBaseModel,
    BaseModel,
    incomeFormConfig(send, options, Signal),
    {
      headerBlock: {
        title: 'Do you have another source of income?',
        subtitle: ['Applicant', '80% complete'],
        progressBar: {
          progress: 80,
          withContainer: true,
        },
      },
      info: {
        title: 'Applicant income details',
        content: [
          {
            copy: [
              'Many receive a source of income outside of standard W2 and 1099 Employment, please tell us what those sources may be.',
            ],
          },
        ],
      },
      form: {
        actions: {
          primary: {
            label: 'Continue',
          },
        },
      },
    },
  );
};

const modalFn = (...args: [any, any]) =>
  withContext({ model: model(...args) })(...args);

export default modalFn;
